import React from "react";
import { Grid, TextField, Drawer, IconButton, Paper } from "@material-ui/core";
import { RegularCard, Table, ItemGrid, Button, FilterPanel } from "components";
import { Link, Route } from 'react-router-dom'
import { fetchAllResources } from 'ducks/resources'
import { withRouter } from "react-router-dom";
import AsTable from "../../../components/HOC/AsTable";
import { NormalizeString } from "../../../utils";
import CloseIcon from '@material-ui/icons/Close';
import Details from "./Details";
import { Resources } from 'utils/variables';
import { connect } from 'react-redux';

class List extends React.Component {

    componentDidMount() {
        this.props.getData(this.props.actionParams && this.props.actionParams);
    }

    handleItemSelected = (event, item) => {
        event.preventDefault()
        const { history } = this.props;
        history.push(`/sellers/${item.id}`)
    }

    render() {
        const { filter, handleFilterChange } = this.props;
        let { data } = this.props;

        if (filter.fullName)
            data = data.filter(x => x.fullName && NormalizeString(x.fullName).includes(NormalizeString(filter.fullName)));

        if (filter.cpf)
            data = data.filter(x => x.cpf && NormalizeString(x.cpf).replace('.', '').includes(NormalizeString(filter.cpf).replace('.', '')));

        return (
            <React.Fragment>

                <RegularCard cardTitle="Vendedoras">
                    <Grid container>
                        <ItemGrid xs={12} sm={12} md={12} style={{
                            position: 'sticky',
                            top: '0',
                            padding: '16px',
                            zIndex: 50
                        }}>
                            <Paper style={{ padding: '16px' }}>
                                <Link to='/sellers/create'>
                                    <Button color='primary'>
                                        Nova vendedora
                            </Button>
                                </Link>

                                <FilterPanel title='Filtrar Lista'>
                                    <TextField
                                        id='fullName'
                                        label='Nome'
                                        value={filter.fullName}
                                        onChange={handleFilterChange} />

                                    <TextField
                                        id='cpf'
                                        label='CPF'
                                        value={filter.cpf}
                                        onChange={handleFilterChange} />
                                </FilterPanel>
                            </Paper>
                        </ItemGrid>
                        <ItemGrid xs={12} sm={12} md={12}>

                            <Table
                                {...this.props}
                                onRefresh={() => this.props.getData(this.props.actionParams && this.props.actionParams)}
                                handleItemSelected={this.handleItemSelected}
                                data={data}
                                cells={[{ id: 'fullName', label: "Nome Completo" },
                                { id: 'cpf', label: "CPF" }]} />
                        </ItemGrid>
                    </Grid>
                </RegularCard>
                <Route path="/sellers/:id">
                    {({ match, history }) => {
                        const isMatch =
                            match &&
                                match.params ? true : false;
                        return (
                            <Drawer
                                variant="persistent"
                                open={isMatch}
                                anchor="right"
                            >
                                {isMatch ? (
                                    <Grid container style={{ maxWidth: '500px' }}>
                                        <IconButton onClick={() => history.replace("/sellers")} style={{ marginTop: '24px', marginBottom: '24px' }}>
                                            <CloseIcon />
                                        </IconButton>
                                        <Details />
                                    </Grid>
                                ) : null}
                            </Drawer>
                        );
                    }}
                </Route>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    data: state.resources['sellers'] || []
});

const mapDispatchToProps = (dispatch) => ({
    getData: () => dispatch(fetchAllResources(Resources.Sellers))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AsTable(List, {
    fullName: '',
    cpf: ''
})));
